import {
  call, put, select, takeLatest, takeEvery,
} from 'redux-saga/effects';
import findResult from '@/utils/resultsHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import ConfigurationService from '../service';
import {
  updateAutoApprovalSuccess,
  updateDefaultRoleSuccess,
  updateConfigurationError,
  showConfigurationSuccess,
  showConfigurationError,
} from '../actions';
import actions, { configurationCodes } from '../constants';

export function* configuration({ category, code }) {
  const { response, error } = yield call(callAdapter, ConfigurationService.configuration(code));
  if (error) {
    yield put(showConfigurationError(category, code, error));
  } else {
    yield put(showConfigurationSuccess(category, code, response));
  }
}
export function* updateApproval({ category }) {
  const configurations = yield select(selectors.configurations);
  const { value: { value } } = findResult(configurations, 'all', configurationCodes.DEFAULT_APPROVAL);
  const { response, error } = yield call(
    callAdapter,
    ConfigurationService.update(configurationCodes.DEFAULT_APPROVAL, { value: !value }),
  );

  if (error) {
    yield put(updateConfigurationError(category, configurationCodes.DEFAULT_APPROVAL, error));
  } else {
    yield put(updateAutoApprovalSuccess(category, response));
  }
}

export function* updateDefaultRole({ category, role }) {
  const { response, error } = yield call(
    callAdapter,
    ConfigurationService.update(configurationCodes.DEFAULT_ROLE, { value: role.code }),
  );

  if (error) {
    yield put(updateConfigurationError(category, configurationCodes.DEFAULT_ROLE, error));
  } else {
    yield put(updateDefaultRoleSuccess(category, { ...response, name: role.name }));
  }
}

export default function* configurationsApi() {
  yield takeEvery(actions.FETCH_CONFIGURATION, configuration);
  yield takeLatest(actions.TOGGLE_AUTO_APPROVAL_CONFIGURATION, updateApproval);
  yield takeLatest(actions.UPDATE_DEFAULT_ROLE_CONFIGURATION, updateDefaultRole);
}
